import { render, staticRenderFns } from "./ListAnnotationsThumbs.vue?vue&type=template&id=65f3bc08&scoped=true"
import script from "./ListAnnotationsThumbs.vue?vue&type=script&lang=js"
export * from "./ListAnnotationsThumbs.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotationsThumbs.vue?vue&type=style&index=0&id=65f3bc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f3bc08",
  null
  
)

export default component.exports